import axios, { AxiosError } from "axios";
import { FetchError } from "@freightsimple/generated-dashboard-openapi-client/runtime";

/** True when the browser got no answer from the API at all (the phone lost
 *  its connection, or Safari cancelled the request). A background fetch that
 *  hits one should keep what it already has and let the next refresh retry.
 *  An answer with an error status is a ResponseError (or an axios error with
 *  a response), not this. An axios timeout is not this either: it can mean
 *  our API hung, so it should still be reported. */
export function isNetworkError(error: unknown): boolean {
  if (error instanceof FetchError) return true;
  return (
    axios.isAxiosError(error) &&
    error.response === undefined &&
    error.code === AxiosError.ERR_NETWORK
  );
}
